import * as React from 'react';

const AppleIcon = (props: any): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none" {...props}>
    <path
      d="M12.2672 9.70517C12.2926 12.4291 14.662 13.3356 14.6883 13.3472C14.6683 13.4111 14.3097 14.639 13.4399 15.9073C12.6881 17.0038 11.9077 18.0963 10.6785 18.1189C9.47062 18.1411 9.08222 17.4042 7.70129 17.4042C6.32078 17.4042 5.88925 18.0963 4.74587 18.1411C3.55933 18.1859 2.65579 16.9554 1.89768 15.8629C0.348577 13.6282 -0.835259 9.54803 0.754333 6.79388C1.54401 5.42616 2.95522 4.56006 4.48696 4.53785C5.65212 4.51568 6.75188 5.32003 7.46416 5.32003C8.17598 5.32003 9.51243 4.35272 10.9174 4.49478C11.5056 4.51921 13.1565 4.73186 14.2167 6.28027C14.1313 6.33311 12.2467 7.42783 12.2672 9.70517ZM9.99717 3.0163C10.6271 2.25543 11.0511 1.19623 10.9354 0.142334C10.0274 0.178749 8.92942 0.7461 8.27812 1.50655C7.69443 2.17997 7.18325 3.25781 7.32117 4.29085C8.33326 4.36898 9.36719 3.77766 9.99717 3.0163Z"
      fill="black"
    />
  </svg>
);

export default AppleIcon;
